import { Behavior } from "../../base/Behavior";
import { TableRowToolsCell } from "./TableRowToolsCell";
import { TableRow } from "./TableRow";
import { TableRowMode } from "./TableRowMode";

export class TableRowBehavior extends Behavior {
    protected constructor() {
        super();
    }

    allowsEdit(tableRow: TableRow, rowAllowsEdit: boolean): boolean {
        if (tableRow.mode === TableRowMode.QUICK_ADD)
            return true;
        return rowAllowsEdit !== false && tableRow.table.allowEdit === true;
    }

    manageEditStateOnModeChange(tableRow: TableRow, newMode: TableRowMode): void {
        if (newMode !== TableRowMode.SEARCH) {
            this.setCellsPrintable(tableRow, tableRow.rowIsPrintable())
        } else {
            this.setCellsPrintable(tableRow, false);
        }
    }

    private setCellsPrintable(tableRow: TableRow, printable: boolean) {
        if (tableRow.table.printableToggleEnabled) {
            for (const cell of tableRow.cells) {
                if (cell.printableToggleEnabled) {
                    cell.printable = printable;
                }
            }
        }
    }

    addToolsCellToRow(row: TableRow, cell: TableRowToolsCell): void {
        if (cell != null) {
            row.addCell(cell);
            row._element.appendChild(cell._element);
        }
    }

    get type(): string {
        return "TableRow";
    }
}

TableRowBehavior.register();
